import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
const faqs = [['¿Necesito autorización del neurólogo?', 'No. El sistema no modifica ni reemplaza ninguna indicación médica. Organiza la rutina diaria para que el tratamiento ya indicado funcione mejor.'], ['¿Los alimentos son caros o difíciles de conseguir?', 'No. Todo se consigue en el supermercado de tu barrio. Sin suplementos importados ni dietéticas especializadas.'], ['¿Sirve tanto para hombres como para mujeres?', 'Absolutamente. El sistema de absorción de la medicación funciona igual en ambos sexos y el protocolo está diseñado para ser efectivo sin distinción de género.'], ['¿Cuándo veo resultados?', 'La mayoría nota los primeros cambios entre el día 7 y el día 14, especialmente en la previsibilidad de los momentos “ON”.'], ['¿La garantía es real?', 'Sí. Si en 30 días no cumplió lo que esperabas, escribís a soportebiomalivido@gmail.com y te devolvemos el 100%. Sin preguntas.'], ['¿Es 100% digital?', 'Sí. Acceso inmediato en PDF. Podés leerlo en el celular, tablet o computadora, e imprimirlo si preferís.']] as const;
const costs = ['Otro mes sin entender por qué la pastilla a veces funciona y a veces no', 'Más días improvisando comidas y rogando que no interfieran con la toma', 'Noches en que tu familiar queda “congelado” y no sabés qué hacer', 'Consultas donde llegás con sensaciones vagas y salís sin respuestas', 'Agotamiento acumulado de cuidar sin un sistema claro que te sostenga', 'Otro año con la misma incertidumbre y el mismo miedo'];
const purchases = [['Susana C.', 'Buenos Aires'], ['Rosa M.', 'Córdoba'], ['Elena P.', 'Rosario'], ['Marcela F.', 'Mendoza']];
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-21">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-23" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-25">
            <p className="text-slate-300" data-id="element-26">
              Abrís los volúmenes. Seguís el sistema.
            </p>
            <p className="mt-4 text-slate-300" data-id="element-27">
              Si en 30 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-28">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-29">
              sin formularios, sin drama.
            </p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-30">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-31">
        <div className="mx-auto max-w-3xl" data-id="element-32">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-33">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-34">
            {faqs.map(([question, answer], index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-35">
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-36">
                    <span data-id="element-37">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-38" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} data-id="element-40">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-41">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-42">
      <div className="mx-auto max-w-4xl" data-id="element-43">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-44">
          ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-45">
          {costs.map(item => <p key={item} className="border-b border-[#1a4a2e] border-l-4 border-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-46">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-47">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <p className="mt-12 text-center text-xl font-bold" data-id="element-48">
          El próximo lunes puede ser diferente.
        </p>
        <p className="mx-auto mt-5 max-w-3xl text-center font-display text-xl font-bold italic text-brand-light sm:text-2xl" data-id="element-49">
          “Tu familiar no está empeorando solo por la enfermedad. Está esperando
          que alguien le dé la rutina correcta.”
        </p>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-50">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-51">
          PROTOCOLO — PARKINSON BAJO CONTROL™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-52">
          El primer sistema práctico para cuidadores argentinos que quieren
          recuperar el control de la rutina diaria de su familiar con Parkinson.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-53">
          Porque tu familiar no está roto. Solo está esperando la sincronización
          correcta.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-54">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-55">
            📧 soportebiomalivido@gmail.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-56">
          © BIOMA LÍVIDO™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-57">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-58">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-59">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-60" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-61">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-62">
              compró Protocolo — Parkinson Bajo Control™
            </p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-63">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}